module.exports = __webpack_public_path__ + "static/media/linkedin.ccf47930.svg";